/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Bring_HInputs */

const en_funnel_ob_bring_h = /** @type {(inputs: Funnel_Ob_Bring_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bring [anything]. It reads it out loud.`)
};

const es_funnel_ob_bring_h = /** @type {(inputs: Funnel_Ob_Bring_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trae [lo que sea]. Lo lee en voz alta.`)
};

/**
* | output |
* | --- |
* | "Bring [anything]. It reads it out loud." |
*
* @param {Funnel_Ob_Bring_HInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_bring_h = /** @type {((inputs?: Funnel_Ob_Bring_HInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Bring_HInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_bring_h(inputs)
	return en_funnel_ob_bring_h(inputs)
});